import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36b0eb6f")

_pushScopeId("data-v-36b0eb6f")
const _hoisted_1 = { class: "l" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看题目")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("题目解析")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交记录")
const _hoisted_5 = { class: "r" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上一题")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下一题")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", {
    class: 'q-ft clearfix' + (_ctx.type == 2 ? ' is-program' : '')
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.type === 2)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            plain: "",
            class: 'btn' + (_ctx.showQuestion ? ' on' : ''),
            onClick: _ctx.handleViewQuestion
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["class", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        class: 'btn' + (_ctx.showAnalysis ? ' on' : ''),
        onClick: _ctx.handleViewAnalysis
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class", "onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        class: 'btn' + (_ctx.showHistory ? ' on' : ''),
        onClick: _ctx.handleViewHistory
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        class: "btn",
        onClick: _ctx.handlePrev
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        class: "btn",
        onClick: _ctx.handleNext
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 2))
})